const Environment = {
    appServiceUrl: process.env.REACT_APP_APP_SERVICE_URL || 'https://keochiinh.com/api'|| 'http://192.168.1.15:3002/api',
};

export default Environment;
